import { useNavigate } from '@tanstack/react-router';
import { ListsOverviewScreen } from '@mrrmlab/feature-lists';

export function ListsRoute() {
  const navigate = useNavigate();
  return (
    <ListsOverviewScreen
      onOpenList={(list) =>
        navigate({ to: '/lists/$listId', params: { listId: list.id } })
      }
      onManageStores={() => navigate({ to: '/einstellungen/geschaefte' })}
    />
  );
}
